/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class MainDrawingSimController implements angular.IController {
        public mainDrawings: MainDrawingPagedResult;
        public filters: ModelFilterViewModel;
        public erroLoadingData: boolean;
        public fileToken: string;
        public isLoading: boolean;

        $onInit = () => { };

        constructor(private $scope: any,
            private buildingService: BuildingService,
            private mainDrawingService: MainDrawingService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService,
            private $mdDialog: any,
            private fileService: FileService,
            private universalStorageService: UniversalStorageService,
            private drawingExportJobService: DrawingExportJobService,
            private textService: TextService,
        ) {
            this.mainDrawings = new MainDrawingPagedResult();
            var vm = this;
            fileService.getFileToken().then((token: string) => vm.fileToken = token);
            this.isLoading = false;
            this.$scope.$on('loadMainDrawingsSim', function (e) {
                vm.loadData(true);
            });
            this.$scope.$on('mainDrawingLoadMoreSim', (e) => {

                vm.loadMore(true);
            });

            this.$scope.imageError = function (sender) {
                if (sender.src != null && sender.src != '' &&
                    sender.src.toLowerCase().match(/(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}$).+|(?=[\w\s\-\(\)\[\]\%\+]+(\.)\w{3,4}[\?])[^\?]*/g)[0].indexOf(".png") > -1 &&
                    sender.src.indexOf('image/resize') == -1) {
                    sender.src = vm.universalStorageService.getThumbnailUrl(sender.src.replace(/\-w100\./g, '.'));
                }
                else {
                    sender.src = "/assets/img/no-image-icon-32.png?x=1";
                }
            }
        }

        public loadData(sim: boolean) {
            if (this.isLoading) {
                return;
            }
            this.mainDrawings = new MainDrawingPagedResult();
            var vm = this;
            this.erroLoadingData = false;
            this.filters = this.buildingService.getFilters();
            this.isLoading = true;
            this.mainDrawingService.search(this.filters, sim).then((data: MainDrawingPagedResult) => {
                vm.mainDrawings.totalNumberOfPages = data.totalNumberOfPages;
                vm.mainDrawings.totalNumberOfRecords = data.totalNumberOfRecords;
                vm.mainDrawings.scrollId = data.scrollId;
                vm.mainDrawings.results = data.results;

                vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                vm.isLoading = false;
            }, () => {
                vm.erroLoadingData = true;
                vm.isLoading = false;
            });
        }

        public loadMore(sim: boolean) {
            if (this.isLoading) {
                return;
            }
            if (this.mainDrawings != null && this.mainDrawings.scrollId != null) {
                var vm = this;
                this.erroLoadingData = false;
                this.isLoading = true;
                this.mainDrawingService.scroll(this.mainDrawings.scrollId, sim).then((data: MainDrawingPagedResult) => {
                    if (data == null) {
                        vm.loadData(sim);
                    }
                    else {
                        vm.mainDrawings.totalNumberOfPages = data.totalNumberOfPages;
                        vm.mainDrawings.totalNumberOfRecords = data.totalNumberOfRecords;
                        vm.mainDrawings.scrollId = data.scrollId;
                        if (data.results == null || data.results.length == 0) {
                            vm.mainDrawings.scrollId = null;
                        }
                        else {
                            vm.mainDrawings.results = vm.mainDrawings.results.concat(data.results);
                        }

                        vm.$scope.vm.totalResultCount = data.totalNumberOfRecords;
                        
                    }
                    vm.isLoading = false;
                }, () => {
                    vm.erroLoadingData = true;
                    vm.isLoading = false;
                });
            }
        }

        public drawingExportJobStart(md: MainDrawingViewModel): void {
            if (md.secondaryDrawingUrl === PositiveNegative.Positive) {
                return;
            }
            md.secondaryDrawingUrl = PositiveNegative.Positive;
            this.drawingExportJobService.start(md);
        }

        public showDialog(url: string, $event) {
            var vm = this;
            var dialog = {
                controller: function () {
                    this.url = url;
                    this.$mdDialog = vm.$mdDialog;
                    this.maxWidth = 200;
                    this.maxHeight = 400;
                    this.resizeWindow = function () {
                        this.maxWidth = window.innerWidth
                            || document.documentElement.clientWidth
                            || document.body.clientWidth;

                        this.maxWidth = this.maxWidth * 0.8;

                        this.maxHeight = window.innerHeight
                            || document.documentElement.clientHeight
                            || document.body.clientHeight - 70;

                        this.maxHeight = this.maxHeight * 0.7;
                    };
                    this.resizeWindow();
                    var self = this;
                    $(window).resize(() => self.resizeWindow());
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/main-drawing.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog);
        }

        public showPreviewDialog(drawing: DrawingViewModel, $event) {
            var vm = this;
            var dialog = {
                controller: function () {
                    this.url = (drawing.url != null && drawing.url != '') ? drawing.url : drawing.mainDrawingUrl;
                    this.fileName = drawing.modelName;
                    this.$mdDialog = vm.$mdDialog;
                    this.maxWidth = 200;
                    this.maxHeight = 400;
                    this.fileToken = vm.fileToken;
                    this.resizeWindow = function () {
                        this.maxWidth = window.innerWidth
                            || document.documentElement.clientWidth
                            || document.body.clientWidth;

                        this.maxWidth = this.maxWidth;

                        this.maxHeight = window.innerHeight
                            || document.documentElement.clientHeight
                            || document.body.clientHeight;

                        this.maxHeight = this.maxHeight;
                    };
                    this.resizeWindow();
                    var self = this;
                    $(window).resize(() => self.resizeWindow());
                },
                controllerAs: 'vm',
                templateUrl: '/app/dialog/floorplan.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog);
        }

        public viewExportLog(fileId: string, $event) {
            var dialog = {
                controller: MainDrawingController.WarningDialogController(fileId, this.textService, this.fileService, this.$mdDialog),
                controllerAs: 'vm',
                templateUrl: '/app/dialog/warning-list.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                targetEvent: $event
            };
            this.$mdDialog.show(dialog)
        }

    }

    MainDrawingSimController.$inject = ['$scope', 'BuildingService', 'MainDrawingService', '$q', '$timeout', '$mdDialog', 'FileService', 'UniversalStorageService', 'DrawingExportJobService', 'TextService'];

    angular
        .module('eseebase')
        .controller('MainDrawingSimController', MainDrawingSimController);
}
